module.exports = __webpack_public_path__ + "img/placeholder_2.3a655b32.svg";